import React from 'react'

const TrustCheck = ({ lightColor, darkColor, circleColor }) => {
  const lightFill = lightColor ? lightColor : '#A0AEC0'
  const darkFill = darkColor ? darkColor : '#4A5568'
  const circleFill = circleColor ? circleColor : '#EDF2F7'
  
  return (
    <svg width="48" height="48" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <circle fill={circleFill} cx="24" cy="24" r="24" />
        <g fillRule="nonzero">
          <path
            d="M15 15.2l9-2.2 9 2.2v9.966c-.002 3.33-1.926 6.375-4.973 7.865L24 35l-4.027-1.969c-3.047-1.49-4.971-4.535-4.973-7.865V15.2z"
            fill={lightFill}
          />
          <path
            d="M22.313 24.227l4.836-4.955a1.105 1.105 0 0 1 1.527.071c.413.43.434 1.111.048 1.565L23.1 26.671c-.437.439-1.137.439-1.575 0l-2.25-2.305a1.173 1.173 0 0 1 .049-1.565 1.105 1.105 0 0 1 1.527-.072l1.462 1.498z"
            fill={darkFill}
          />
        </g>
      </g>
    </svg>
  )
}

export default TrustCheck
